export default () => ({
  amount: '',
  comment: '',
  contract: '',
  category: '',
  periodId: '',
  continueBilling: '',
  paymentMethod: '',
  paymentForm: '',
  doNotBillTransaction: false
});
